import { Transaction, MonthSummary } from './types';

// Mock transactions for 3 months (August, September, October)
export const mockTransactions: Transaction[] = [
  // October (36 transactions)
  { id: 'oct-1', name: 'Loaf and Jug', amount: 35, date: '2025-10-23', type: 'expense' },
  { id: 'oct-2', name: 'JCPenny', amount: 15.23, date: '2025-10-22', type: 'expense' },
  { id: 'oct-3', name: 'King Soopers', amount: 45.86, date: '2025-10-19', type: 'expense' },
  { id: 'oct-4', name: 'Buckeys', amount: 19.67, date: '2025-10-08', type: 'expense' },
  { id: 'oct-5', name: 'Netflix', amount: 15.99, date: '2025-10-01', type: 'expense' },
  { id: 'oct-6', name: 'Rent Payment', amount: 1200, date: '2025-10-01', type: 'expense' },
  { id: 'oct-7', name: 'Shell Gas', amount: 52.34, date: '2025-10-05', type: 'expense' },
  { id: 'oct-8', name: 'Chipotle', amount: 12.45, date: '2025-10-10', type: 'expense' },
  { id: 'oct-9', name: 'Target', amount: 87.23, date: '2025-10-12', type: 'expense' },
  { id: 'oct-10', name: 'Paycheck', amount: 2000, date: '2025-10-15', type: 'income' },
  { id: 'oct-11', name: 'Amazon', amount: 43.21, date: '2025-10-16', type: 'expense' },
  { id: 'oct-12', name: 'Starbucks', amount: 6.75, date: '2025-10-18', type: 'expense' },
  { id: 'oct-13', name: 'Gym Membership', amount: 29.99, date: '2025-10-20', type: 'expense' },
  { id: 'oct-14', name: 'Electric Bill', amount: 85.67, date: '2025-10-21', type: 'expense' },
  { id: 'oct-15', name: 'Water Bill', amount: 42.30, date: '2025-10-21', type: 'expense' },
  { id: 'oct-16', name: 'Internet Bill', amount: 79.99, date: '2025-10-22', type: 'expense' },
  { id: 'oct-17', name: 'Uber Eats', amount: 28.50, date: '2025-10-24', type: 'expense' },
  { id: 'oct-18', name: 'Walmart', amount: 134.56, date: '2025-10-25', type: 'expense' },
  { id: 'oct-19', name: 'Car Insurance', amount: 145.00, date: '2025-10-26', type: 'expense' },
  { id: 'oct-20', name: 'Phone Bill', amount: 65.00, date: '2025-10-27', type: 'expense' },
  { id: 'oct-21', name: 'Spotify', amount: 10.99, date: '2025-10-28', type: 'expense' },
  { id: 'oct-22', name: 'Dollar Tree', amount: 23.45, date: '2025-10-28', type: 'expense' },
  { id: 'oct-23', name: 'Home Depot', amount: 67.89, date: '2025-10-29', type: 'expense' },
  { id: 'oct-24', name: 'Movie Tickets', amount: 32.00, date: '2025-10-29', type: 'expense' },

  // September (42 transactions)
  { id: 'sep-1', name: 'Paycheck', amount: 2000, date: '2025-09-01', type: 'income' },
  { id: 'sep-2', name: 'Rent Payment', amount: 1200, date: '2025-09-01', type: 'expense' },
  { id: 'sep-3', name: 'Costco', amount: 156.78, date: '2025-09-03', type: 'expense' },
  { id: 'sep-4', name: 'Shell Gas', amount: 48.90, date: '2025-09-05', type: 'expense' },
  { id: 'sep-5', name: 'Pizza Hut', amount: 24.56, date: '2025-09-06', type: 'expense' },
  { id: 'sep-6', name: 'CVS Pharmacy', amount: 32.11, date: '2025-09-08', type: 'expense' },
  { id: 'sep-7', name: 'Best Buy', amount: 199.99, date: '2025-09-10', type: 'expense' },
  { id: 'sep-8', name: 'Panera Bread', amount: 14.23, date: '2025-09-11', type: 'expense' },
  { id: 'sep-9', name: 'Target', amount: 92.45, date: '2025-09-12', type: 'expense' },
  { id: 'sep-10', name: 'Electric Bill', amount: 78.34, date: '2025-09-13', type: 'expense' },
  { id: 'sep-11', name: 'Paycheck', amount: 2000, date: '2025-09-15', type: 'income' },
  { id: 'sep-12', name: 'Amazon', amount: 67.89, date: '2025-09-16', type: 'expense' },
  { id: 'sep-13', name: 'Gym Membership', amount: 29.99, date: '2025-09-18', type: 'expense' },
  { id: 'sep-14', name: 'Starbucks', amount: 8.45, date: '2025-09-19', type: 'expense' },
  { id: 'sep-15', name: 'King Soopers', amount: 87.23, date: '2025-09-20', type: 'expense' },
  { id: 'sep-16', name: 'Netflix', amount: 15.99, date: '2025-09-21', type: 'expense' },
  { id: 'sep-17', name: 'Shell Gas', amount: 51.23, date: '2025-09-22', type: 'expense' },
  { id: 'sep-18', name: 'Chipotle', amount: 13.67, date: '2025-09-23', type: 'expense' },
  { id: 'sep-19', name: 'Walmart', amount: 103.45, date: '2025-09-25', type: 'expense' },
  { id: 'sep-20', name: 'Internet Bill', amount: 79.99, date: '2025-09-26', type: 'expense' },

  // August (44 transactions)
  { id: 'aug-1', name: 'Paycheck', amount: 1800, date: '2025-08-01', type: 'income' },
  { id: 'aug-2', name: 'Rent Payment', amount: 1200, date: '2025-08-01', type: 'expense' },
  { id: 'aug-3', name: 'King Soopers', amount: 124.56, date: '2025-08-02', type: 'expense' },
  { id: 'aug-4', name: 'Shell Gas', amount: 46.78, date: '2025-08-04', type: 'expense' },
  { id: 'aug-5', name: 'Target', amount: 76.89, date: '2025-08-05', type: 'expense' },
  { id: 'aug-6', name: 'Starbucks', amount: 7.25, date: '2025-08-06', type: 'expense' },
  { id: 'aug-7', name: 'Electric Bill', amount: 92.45, date: '2025-08-08', type: 'expense' },
  { id: 'aug-8', name: 'Water Bill', amount: 38.90, date: '2025-08-08', type: 'expense' },
  { id: 'aug-9', name: 'Amazon', amount: 134.22, date: '2025-08-10', type: 'expense' },
  { id: 'aug-10', name: 'Gym Membership', amount: 29.99, date: '2025-08-12', type: 'expense' },
  { id: 'aug-11', name: 'Chipotle', amount: 11.45, date: '2025-08-13', type: 'expense' },
  { id: 'aug-12', name: 'Netflix', amount: 15.99, date: '2025-08-14', type: 'expense' },
  { id: 'aug-13', name: 'Walmart', amount: 145.67, date: '2025-08-15', type: 'expense' },
  { id: 'aug-14', name: 'Car Insurance', amount: 145.00, date: '2025-08-16', type: 'expense' },
  { id: 'aug-15', name: 'Phone Bill', amount: 65.00, date: '2025-08-17', type: 'expense' },
  { id: 'aug-16', name: 'Shell Gas', amount: 49.34, date: '2025-08-18', type: 'expense' },
  { id: 'aug-17', name: 'King Soopers', amount: 98.76, date: '2025-08-19', type: 'expense' },
  { id: 'aug-18', name: 'Starbucks', amount: 6.50, date: '2025-08-20', type: 'expense' },
  { id: 'aug-19', name: 'Target', amount: 67.89, date: '2025-08-21', type: 'expense' },
  { id: 'aug-20', name: 'Internet Bill', amount: 79.99, date: '2025-08-22', type: 'expense' },
];

export const mockMonthSummaries: MonthSummary[] = [
  {
    month: 'August',
    transactionCount: 44,
    moneyIn: 1800,
    moneyOut: 2000,
    netChange: -200,
  },
  {
    month: 'September',
    transactionCount: 42,
    moneyIn: 2000,
    moneyOut: 1400,
    netChange: 600,
  },
  {
    month: 'October',
    transactionCount: 36,
    moneyIn: 2000,
    moneyOut: 1500,
    netChange: 500,
  },
];

// Calculate summaries for the last 3 calendar months (most recent → oldest)
export const calculateMonthSummaries = (transactions: Transaction[]): MonthSummary[] => {
  const now = new Date();
  const last3Months: MonthSummary[] = [];

  // Generate the last 3 months (current month and 2 before)
  for (let i = 0; i < 3; i++) {
    const monthDate = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const monthName = monthDate.toLocaleString('default', { month: 'long' });
    const year = monthDate.getFullYear();
    const monthNum = monthDate.getMonth();

    // Initialize summary for this month
    const summary: MonthSummary = {
      month: monthName,
      transactionCount: 0,
      moneyIn: 0,
      moneyOut: 0,
      netChange: 0,
    };

    // Filter transactions for this specific month
    transactions.forEach((t) => {
      const txDate = new Date(t.date);
      if (txDate.getFullYear() === year && txDate.getMonth() === monthNum) {
        summary.transactionCount++;
        if (t.type === 'income') {
          summary.moneyIn += t.amount;
        } else {
          summary.moneyOut += t.amount;
        }
      }
    });

    summary.netChange = summary.moneyIn - summary.moneyOut;
    last3Months.push(summary);
  }

  return last3Months; // Already in order: most recent → oldest
};
